import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { getCurrentTutorProfile } from "../../firestore/Functions/tutorProfileFunctions";
import { TutorProfileView } from "../../firestore/Types/TutorProfileSchema";
import { Approvals } from "./Approvals";
import { Availabilities } from "./Availabilities";
import { useUtility } from "../../contexts/auth/UtilityContext";

export function TutorExclusiveComponents() {

    const { currentUser } = useAuth();

    const { setNewToast } = useUtility();

    const [tutorProfile, setTutorProfile] = useState<TutorProfileView>({} as TutorProfileView);

    const handleRefreshTutorProfile = async () => {
        const tutorProfile = await getCurrentTutorProfile().catch((error) => {
            setNewToast({title: "Internal Error", message: error.message, toastType: "error"})
        });
        if (tutorProfile) {
            setTutorProfile(tutorProfile);
        }
    }

    useEffect(() => {
        const getTutorProfile = async () => {
            const tutorProfile = await getCurrentTutorProfile().catch((error) => {
                setNewToast({title: "Internal Error", message: error.message, toastType: "error"})
            });
            if (tutorProfile) {
                setTutorProfile(tutorProfile);
            }
        };
        getTutorProfile();
    }, [currentUser, setNewToast]);
    
    return (
        <div className="gap-4 grid  md:col-span-6 sm:col-span-12">
            <Approvals /><Availabilities tutorProfile={tutorProfile} handleRefresProfile={handleRefreshTutorProfile} />{/*<Subjects tutorProfile={tutorProfile}/>*/}
        </div>
        );
}